module.exports = __webpack_public_path__ + "media/images/401playlogo--693e8016.png";